import { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl/maplibre';
import { useGeofencesQueryV1, Geofence, getGeofenceIdentifier } from '@/api/v1/geofence-api';

export function GeofenceLayer() {
  const { data: geofences, isLoading, error } = useGeofencesQueryV1();

  if (isLoading || error || !geofences || geofences.length === 0) {
    return null;
  }

  return (
    <>
      {geofences.map(geofence => (
        <GeofenceItem 
          key={getGeofenceIdentifier(geofence)} 
          geofence={geofence} 
        />
      ))}
    </>
  );
}

interface GeofenceItemProps {
  geofence: Geofence;
}

export function GeofenceItem({ geofence }: GeofenceItemProps) {
  const identifier = useMemo(() => getGeofenceIdentifier(geofence), [geofence]);
  
  const geoJsonData = useMemo(() => {
    const geoJson = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: { id: identifier },
          geometry: { type: 'Polygon', coordinates: geofence.geometry }
        }
      ]
    };
    return geoJson;
  }, [identifier, geofence.geometry]);

  const fillLayerStyle = {
    id: `geofence-fill-${identifier}`,
    type: 'fill' as const,
    paint: {
      'fill-color': '#0080FF',
      'fill-opacity': 0.15
    }
  };

  const outlineLayerStyle = {
    id: `geofence-outline-${identifier}`,
    type: 'line' as const,
    paint: {
      'line-color': '#0080FF',
      'line-width': 2
    }
  };

  return (
    <Source 
      id={`geofence-source-${identifier}`} 
      type="geojson" 
      data={geoJsonData as unknown as GeoJSON.FeatureCollection<GeoJSON.Geometry>}
    >
      <Layer {...fillLayerStyle} />
      <Layer {...outlineLayerStyle} />
    </Source>
  );
}
